import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Portfolio is in the works, be sure to come back later!
        </p>
      </header>
    </div>
  );
}


export default App;
